"use strict";

exports.__esModule = true;
exports.default = void 0;

var _is = require("../../utilities/is");
/**
 * A helper function that works like Sass' @for.
 *
 * @param {Array<any> | Object} list The list to iterate through.
 * @param {Function} callback Function to generate the styles.
 * @returns {string} The compiled CSS styles.
 */


var forEach = function forEach(list, callback) {
  if (!Array.isArray(list) && !(0, _is.isObject)(list) || !(0, _is.isFunction)(callback)) return '';

  if ((0, _is.isObject)(list)) {
    return (// $FlowFixMe
      Object.keys(list) // $FlowFixMe
      .map(function (key, index) {
        return callback(key, list[key], index);
      }).join(' ')
    );
  }

  return list.map(callback).join(' ');
};

var _default = forEach;
exports.default = _default;